import React, { useState } from 'react';
import { handleInternalLogin, handleExternalLogin } from './Authentication';
import './Login.css';

const Login = ({ setUser }) => {
    const [loginMode, setLoginMode] = useState('internal'); // 'internal' or 'external'
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const onExternalSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        
        if (!email || !password) {
            setError('Please enter both email and password.');
            setLoading(false);
            return;
        }

        const result = await handleExternalLogin(email, password, setUser);
        if (!result.success) {
            setError(result.error);
        }
        setLoading(false);
    };

    return (
        <div className="login-container">
            <div className="login-background">
                <div className="shape shape-1"></div>
                <div className="shape shape-2"></div>
                <div className="shape shape-3"></div>
            </div>
            
            <div className="login-card glass-panel">
                <div className="login-header">
                    <div className="logo-container">
                        <div className="logo-icon">IPA</div>
                    </div>
                    <h1>Intelligent Palm Analytics</h1>
                    <p>AI-Palm Care Solution</p>
                </div>

                <div className="login-tabs">
                    <button 
                        className={`tab-btn ${loginMode === 'internal' ? 'active' : ''}`}
                        onClick={() => { setLoginMode('internal'); setError(''); }}
                    >
                        Internal User
                    </button>
                    <button 
                        className={`tab-btn ${loginMode === 'external' ? 'active' : ''}`}
                        onClick={() => { setLoginMode('external'); setError(''); }}
                    >
                        External User
                    </button>
                </div>

                <div className="login-content">
                    {loginMode === 'internal' ? (
                        <div className="internal-login-section animate-fade-in">
                            <p className="login-description">
                                Log in securely using your Genting Plantations Microsoft Enterprise ID.
                            </p>
                            <button className="primary-btn" onClick={handleInternalLogin}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/></svg>
                                Authenticate via Entra ID
                            </button>
                        </div>
                    ) : (
                        <form className="external-login-form animate-fade-in" onSubmit={onExternalSubmit}>
                            <div className="input-group">
                                <label>Email Address</label>
                                <input 
                                    type="email" 
                                    placeholder="Enter your email" 
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div className="input-group">
                                <label>Password</label>
                                <input 
                                    type="password" 
                                    placeholder="Enter your password" 
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                            
                            {error && <div className="error-message">{error}</div>}
                            
                            <button type="submit" className="primary-btn" disabled={loading}>
                                {loading ? 'Authenticating...' : 'Sign In'}
                            </button>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Login;
